module.exports = __webpack_public_path__ + "static/media/Indio.3df9e067.png";